import { environment } from '~app/environment';

import {
  webRequestClient,
  type RequestParams,
  type ScpClient,
} from '~shared/scp-client';

import type { ProductApi, ProductRequestParams } from './product-api';

import type { Product } from '../product';

type Options = { host: string };

export class GatewayProductApi implements ProductApi {
  scpClient: ScpClient;
  host: string;

  constructor(scpClient: ScpClient, options: Options) {
    this.scpClient = scpClient;
    this.host = options.host;
  }

  getProductById(params: ProductRequestParams): Promise<Product> {
    return this.makeRequest<Product>({
      method: 'get-by-id',
      service: 'public/products',
      payload: params,
    });
  }

  private makeRequest<T>(
    params: Partial<RequestParams> & { method: string; service: string }
  ) {
    return this.scpClient
      .call<T>({
        host: this.host,
        version: 'v1',
        domain: 'merchant-portal',
        withCredentials: true,
        withLeadingDomain: true,
        ...params,
      })
      .then((response) => response.payload);
  }
}

export const gatewayProductApi = new GatewayProductApi(webRequestClient, {
  host: environment.API_HOST,
});
